import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/art-remark";

export default createStore({ Model });
